import {mapGetters} from 'vuex';

export default {
    name: 'propertyBaseRecordRental',
    inject: ['$eventBus'],
    components: {},
    data: function () {
        return {
            autoPop: false,
        };
    },
    methods: {
        popMapView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 0, popStreetView: false });
        },
        show3rdPartyForm(id, url, cta) {
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                id: id,
                url: url,
                zipcode: this.dpp.geo.zipcode,
                price: this.dpp.price,
                propertyType: this.dpp.propertyType,
                houseRealStatus: this.dpp.houseRealStatus,
                trigger: this.$options.name,
                cta: cta,
                isAutoPop: this.autoPop,
            });
        },
        openSchool() {
            this.$eventBus.$emit('property-staticmap-select', 0);
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
        propertyOrientation() {
            // return this.getLocalHighlight && this.getLocalHighlight.property && this.getLocalHighlight.property.property_orientation
            return '';
        },
        countyName() {
            let county = this.dpp.geo.county;
            return county && county.endsWith('County') ? county.replace('County', '') : county;
        },
    },
    mounted() {
        const that = this;
        this.$eventBus.$on('show-dpp-rental-pop-btn', function (data) {
            that.show3rdPartyForm(data.utmcta, data.url, data.cd);
        });
    },
    beforeUnmount() {
        this.$eventBus.$off('show-dpp-rental-pop-btn');
    },
};